angular.module("questionarioAdv.module")
    .component("correzione", {
        templateUrl: "ng/components/questionarioAdv/correzione/correzione.view.html",
        bindings: {
            model: '=',
            exportValidationComponent: '&'
        },
        controller: CorrezioneController,
        controllerAs: "correzioneCtrl"
    })

function CorrezioneController(
    $timeout
) {

    var self = this;


    self.$onInit = function () {

        $timeout(() => {
            self.checkValidity();
        }, 500)


    }

    self.handleChange = function (parameter, value) {
        if (parameter == 'radio' && !value) {
            self.model.messaggio = "";
        }

        self.checkValidity();

    }

    self.checkValidity = function () {

        if (self.model.daCorreggere) {
            if (self.model.messaggio) {
                self.exportValidationComponent({
                    valid: true
                })
            } else {
                self.exportValidationComponent({
                    valid: false
                })

            }
        } else {
            self.exportValidationComponent({
                valid: true
            })

        }


    }
}